import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "w-full flex px-6"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_3 = { class: "flex flex-col w-full" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Tab = _resolveComponent("Tab");
    const _component_Form = _resolveComponent("Form");
    const _component_modal = _resolveComponent("modal");
    return (_ctx.user)
        ? _withDirectives((_openBlock(), _createBlock(_component_modal, {
            key: 0,
            onClose: _cache[3] || (_cache[3] = ($event) => (_ctx.closeModal()))
        }, {
            header: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('user.editUser')) + " " + _toDisplayString(_ctx.editableUser.username), 1)
            ]),
            default: _withCtx(() => [
                (!_ctx.config.env.isAppPreregistrationEnabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_Tab, {
                            selectedTab: _ctx.currentTab,
                            "onUpdate:selectedTab": _cache[0] || (_cache[0] = ($event) => ((_ctx.currentTab) = $event)),
                            tabs: _ctx.tabs
                        }, null, 8, ["selectedTab", "tabs"])
                    ]))
                    : _createCommentVNode("", true),
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    (_ctx.currentTab === _ctx.tabs[1])
                        ? (_openBlock(), _createBlock(_component_Form, {
                            key: 0,
                            "form-data": _ctx.recoverUserForm,
                            "onUpdate:form-data": _cache[1] || (_cache[1] = ($event) => ((_ctx.recoverUserForm) = $event)),
                            onCancel: _ctx.closeModal,
                            onSubmit: _ctx.sendUserRecovery
                        }, null, 8, ["form-data", "onCancel", "onSubmit"]))
                        : (_openBlock(), _createBlock(_component_Form, {
                            key: 1,
                            "form-data": _ctx.editUserForm,
                            "onUpdate:form-data": _cache[2] || (_cache[2] = ($event) => ((_ctx.editUserForm) = $event)),
                            onSubmit: _ctx.editUserDetails,
                            onCancel: _ctx.closeModal
                        }, null, 8, ["form-data", "onSubmit", "onCancel"]))
                ])
            ]),
            _: 1
        }, 512)), [
            [_vShow, _ctx.show]
        ])
        : _createCommentVNode("", true);
}
